/**
 * WaiverStickyBar — persistent "Sign your waiver" call-to-action pinned to
 * the bottom of the parent area on desktop (md+). Sachin 2026-06: "get
 * them to easily find it — maybe both a pop up and a button at the bottom."
 *
 * On mobile the same job is done by the tappable "Sign your waiver" strip
 * inside the bottom nav (ParentLayout → ParentMobileNav), so this bar is
 * desktop-only to avoid stacking two bars on a phone.
 */
import { Link } from "react-router-dom";
import { FileSignature, ArrowRight } from "lucide-react";

export default function WaiverStickyBar({ count = 0 }) {
    if (!count) return null;
    const many = count > 1;
    return (
        <div
            data-testid="waiver-sticky-bar"
            className="hidden md:flex fixed bottom-0 left-0 right-0 z-40 items-center justify-between gap-4 border-t border-amber-500/40 bg-amber-500/10 backdrop-blur px-6 py-3"
        >
            <div className="flex items-center gap-3 min-w-0">
                <FileSignature className="w-5 h-5 text-amber-300 flex-shrink-0" />
                <div className="min-w-0">
                    <div className="text-sm font-semibold text-white">
                        {many
                            ? `${count} waivers still need signing`
                            : "Your waiver still needs signing"}
                    </div>
                    <div className="text-xs text-amber-200/80 truncate">
                        Required before your next session — takes about 30 seconds.
                    </div>
                </div>
            </div>
            <Link
                to="/welcome/waiver"
                data-testid="waiver-sticky-bar-sign"
                className="inline-flex items-center gap-2 text-xs tracking-[0.15em] uppercase bg-brand-red hover:bg-brand-red/90 text-white font-semibold px-5 py-2.5 rounded transition-colors flex-shrink-0"
            >
                <FileSignature className="w-4 h-4" /> Sign {many ? "waivers" : "waiver"}
                <ArrowRight className="w-3.5 h-3.5" />
            </Link>
        </div>
    );
}
